import React from 'react';
import Button from './button';

export default (props) => <Button flat={true} {...props} />;
